import React from "react";
import { getExperienceYearsList, PROFESSION_TITLES } from "../registrationWizardConstants";
import { isValidProfession } from "../registrationWizardValidation";
import RegistrationWizardState from "../registrationWizardState";

const ClinicalProfileStep = ({ showValidation }) => {
  const d = RegistrationWizardState.getStepData();
  const years = getExperienceYearsList();
  const professionValid = isValidProfession(d.profession.value);

  return (
    <div>
      <h2 className="clinician-onboard-title">Clinical Profile</h2>
      <p className="clinician-onboard-subtitle">Tell us about your professional background.</p>

      <div className="clinician-onboard-field">
        <label>
          Profession <span className="required">*</span>
        </label>
        <select
          className={`clinician-onboard-select ${
            showValidation && !professionValid ? "invalid" : ""
          }`}
          value={professionValid ? d.profession.value : ""}
          onChange={(e) => RegistrationWizardState.updateField("profession", e.target.value)}
        >
          <option value="">Select your profession</option>
          {PROFESSION_TITLES.map((p) => (
            <option key={p.value} value={p.value}>
              {p.label}
            </option>
          ))}
        </select>
        {showValidation && !professionValid && (
          <p className="clinician-onboard-field-error" role="alert">
            Please select your profession
          </p>
        )}
      </div>

      <div className="clinician-onboard-field">
        <label>Year started practicing</label>
        <select
          className="clinician-onboard-select"
          value={d.experienceSince.value}
          onChange={(e) => RegistrationWizardState.updateField("experienceSince", e.target.value)}
        >
          <option value="">Select year</option>
          {years.map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ClinicalProfileStep;
